import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function getInsuranceReport(data) {
    return Networking.PostApi(ApiValues.getInsuranceReport, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}
export default getInsuranceReport